'use client';

import { Box } from '@terra/ui-styled-system';
import { useTranslations } from 'next-intl';

const THOUGHT_LENGTH_BUCKETS = [
  { maxWords: 100, key: 'thoughtLength.briefly' },
  { maxWords: 300, key: 'thoughtLength.moderately' },
] as const;

const LONGEST_THOUGHT_LENGTH_KEY = 'thoughtLength.longly';

export function TraceThoughtLabel({ text }: { text: string }) {
  const t = useTranslations('designSystem.chat');
  const wordCount = text.trim().split(/\s+/).filter(Boolean).length;
  const lengthLabel =
    THOUGHT_LENGTH_BUCKETS.find(({ maxWords }) => wordCount <= maxWords)?.key ??
    LONGEST_THOUGHT_LENGTH_KEY;

  return (
    <>
      <Box as="span">{t('thought')}</Box>
      <Box as="span" aria-hidden="true">
        •
      </Box>
      <Box as="span">{t(lengthLabel)}</Box>
    </>
  );
}
